import React, { useMemo } from 'react';
import { Table, Input, Button, Row, Col, Label, TabPane } from 'reactstrap';
import { useSortBy, useTable } from "react-table";
// Include Translation tool
import { useTranslate } from "react-translate";
import { useSelector } from 'react-redux';

const KiLabEditor_analytes = () => {

    const tEditor = useTranslate('kilab-editor');
    const study = useSelector(state => state.kiLabReducer.study);
    const analytes = study && study.study_data ? JSON.parse(study.study_data.report_data) : [];

    // Genera un array de años desde 1920 hasta el año vigente
    const years = [];
    const currentYear = new Date().getFullYear();

    for (let year = 1920; year <= currentYear; year++) {
        years.push(year);
    }

    const data = useMemo(
        //|| ('Set ID - NTE' in el)
        () => analytes && analytes.length ? analytes.map(p => {
            
            const tableData = {
                c1: p?.['Observation Identifier'].replace(/^([\S]{1,})\s/, ""),
                c2: p?.['Observation Value'],
                c3: p?.['Units'],
                c4: p?.['References Range'],
                c5: p?.['Abnormal Flags'],
                c6: p?.['Comment'].map((commentLine, index) => {
                    return <><p key={index}>{commentLine}</p></>
                }),
            };

            return { ...tableData };

            //}

        }) : [],
        //eslint-disable-next-line
        [study]
    );

    const columns = useMemo(
            () => [
                {
                    Header: `${tEditor('examination')}`,
                    accessor: "c1",
                    defaultCanSort: true
                },
                {
                    Header: `${tEditor('result')}`,
                    accessor: "c2",
                    disableSortBy: true,
                },
                {
                    Header: `${tEditor('unit')}`,
                    accessor: "c3",
                    disableSortBy: true,
                },
                {
                    Header: `${tEditor('ref-range')}`,
                    accessor: "c4",
                    disableSortBy: true,
                },
                {
                    Header: `${tEditor('abnormal-flags')}`,
                    accessor: "c5",
                    disableSortBy: true,
                },
                {
                    Header: `${tEditor('comment')}`,
                    accessor: "c6",
                    disableSortBy: true,
                },
            ],
            //eslint-disable-next-line
            [study]
        );

    const {
            getTableProps,
            getTableBodyProps,
            headerGroups,
            rows,
            prepareRow,
    } = useTable({ columns, data, initialState: { hiddenColumns: ['c5'] } }, useSortBy);

    return (
            <TabPane tabId="tab-result">
                <Table {...getTableProps()}>
                    <thead>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th
                                        className={`session-table-header`}
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                    >
                                        {column.render('Header')}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {rows.map((row, i) => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps((state, rowInfo) => {
                                    if (rowInfo && rowInfo.row) {
                                        return {
                                            style: {
                                                backgroundColor: rowInfo.row.values.c5 !== '' ? '#ffdddd' : '',
                                            },
                                            key: `tr-${i}`
                                        }
                                    } else return { key: `tr-${i}` }
                                })}
                                    
                                >
                                    {row.cells.map((cell, j) => {
                                        return (
                                            <td
                                                {...cell.getCellProps({key: `td-${j}-row-${i}`})}
                                            >
                                                {cell.render('Cell')}
                                            </td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            </TabPane>
    );
}
export default KiLabEditor_analytes;